(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  function setHeaderBannerHeight() {
  const banner = document.getElementById('shopify-section-brand-announcement-bar');
  if (banner) {
    document.documentElement.style.setProperty('--header-banner-height', `${banner.offsetHeight}px`);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  setHeaderBannerHeight();
});

  (function () {
    function initCcSearch() {
      document.querySelectorAll('[data-cc-search]').forEach(function (wrap) {
        if (wrap.dataset.ccSearchReady === 'true') return;
        wrap.dataset.ccSearchReady = 'true';

        var toggle = wrap.querySelector('[data-cc-search-toggle]');
        var panel = wrap.querySelector('[data-cc-search-panel]');
        if (!toggle || !panel) return;

        var input = panel.querySelector('input[type="search"]');

        function focusInput() {
          if (!input) return;
          try {
            input.focus({ preventScroll: true });
          } catch (error) {
            input.focus();
          }
        }

        function open() {
          wrap.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          window.requestAnimationFrame(focusInput);
          window.setTimeout(focusInput, 150);
        }

        function close() {
          wrap.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          if (wrap.classList.contains('is-open')) {
            close();
          } else {
            open();
          }
        });

        toggle.addEventListener('keydown', function (event) {
          if (!wrap.classList.contains('is-open')) return;
          if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            focusInput();
            return;
          }
          if (event.key.length === 1 && input) {
            event.preventDefault();
            focusInput();
            input.value += event.key;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });

        document.addEventListener('click', function (event) {
          if (!wrap.contains(event.target)) close();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') close();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCcSearch);
    } else {
      initCcSearch();
    }

    document.addEventListener('shopify:section:load', initCcSearch);
  })();

  (function () {
    function syncNavIndent() {
      var root = document.documentElement;
      if (window.innerWidth < 990) {
        root.style.removeProperty('--cc-nav-indent');
        return;
      }
      var nav = document.querySelector('.header__inline-menu');
      var anchor = document.querySelector('.ccbs__inner--page, .ccsn__inner--page');
      if (!nav || !anchor) {
        root.style.removeProperty('--cc-nav-indent');
        return;
      }
      var navLeft = nav.getBoundingClientRect().left;
      var boxLeft = anchor.getBoundingClientRect().left;
      var indent = Math.max(0, Math.round(navLeft - boxLeft));
      root.style.setProperty('--cc-nav-indent', indent + 'px');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncNavIndent);
    } else {
      syncNavIndent();
    }
    window.addEventListener('load', syncNavIndent);
    window.addEventListener('resize', syncNavIndent);
    document.addEventListener('shopify:section:load', syncNavIndent);
  })();

  } catch(e) { console.error(e); }
})();
})();
